import { SaveButton } from "@/components/button/SaveEditCancel/SaveButton";
import styles from "./FormAddNewUser.module.css";
import { CancelButton } from "@/components/button/SaveEditCancel/CancelButton";
import { MouseEventHandler } from "react";
import { FormAddNewUser } from "@/hooks/User/useFormAddNewUser";

interface ButtonsBlockProps {
  handleSubmit: (fn: any) => MouseEventHandler<HTMLButtonElement | undefined>;
  onSubmit: (data: FormAddNewUser) => void;
  isHide: () => void;
}

export const ButtonsBlock = ({ handleSubmit, onSubmit, isHide }: ButtonsBlockProps) => {
  return (
    <div className={styles.modalButtons}>
      <SaveButton onClick={handleSubmit(onSubmit)} type="submit">
        Сохранить
      </SaveButton>
      <CancelButton type="button" onClick={isHide}>
        Закрыть
      </CancelButton>
    </div>
  );
};
